import { createClient } from "@supabase/supabase-js";

// Environment variables validation
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env file.'
  );
}

// Supabase client configuration
const supabaseConfig = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  realtime: {
    params: {
      eventsPerSecond: 2
    }
  }
};

// Create and export the Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, supabaseConfig);

// Export auth status check function
export const checkAuthStatus = async () => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) {
      return { session: null, error };
    }
    return { session, error: null };
  } catch (error) {
    return { session: null, error };
  }
};

// Database helper types
export const Database = {
  Tables: {
    profiles: {
      Row: {
        id: 'string',
        onboarding_completed: 'boolean',
        hasactivesubscription: 'boolean',
        hasActiveSubscription: 'boolean',
        updated_at: 'string'
      }
    }
  }
}; 